// Top level libraries and 3rd party dependencies
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { array, func, number, object } from 'prop-types';
import { equals } from 'ramda';

// Redux
import { connect } from 'react-redux';
import { getSessionTime } from '../../actions/session/sessionActions';

import { withChatContext } from '../../context';
import { CONVERSATION_POLL_INTERVAL } from '../../constants/AppConstants';
import Menu from './Menu';
import {getAllConversations, switchConversation} from '../../actions/menuActions';


class MenuContainer extends Component {
    static propTypes = {
        error: object,
        getAllConversations: func,
        loadingState: object,
        location: object,
        logoutRequest: func,
        history: object,
        match: object,
        conversationList: array,
        sessionTime: number,
        timerStart: func,
        switchConversation: func,
    };

    constructor(props) {
        super(props);

        this.state = {
            conversationList: [],
            time: {},
            seconds: 0,
        };

        this.polling = undefined;
        this.timer = 0;
    }

    // Component loads, starts browser-level session timer, starts message polling.
    componentDidMount() {
        this.props.getSessionTime();
        this.props.getAllConversations();
        this.polling = setInterval(this.pollConversations, CONVERSATION_POLL_INTERVAL);
    }

    componentDidUpdate(prevProps) {
        const { error, sessionTime } = this.props;
        this.setState(this.updateConversationsIfNecessary);

        if (prevProps.sessionTime !== sessionTime && !error) {
            this.setState(this.mapSessionTimeRemaining, () => this.initBrowserSessionTimer());
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.polling);
    }

    // TODO (I'm not gonna do it) move session time out as a parent component of Menu and Chat routes
    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds,
        }, () => {
            // Check if we're at zero.
            if (seconds === 0) {
                clearInterval(this.timer);
            }
        });
    };

    // Begin timer with sessionTimeRemaining from API
    initBrowserSessionTimer = () => {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar }, () => this.startTimer());
    };

    pollConversations = () => !this.props.error ? this.props.getAllConversations() : clearInterval(this.polling);

    startTimer = () => {
        if (this.timer === 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    };

    secondsToTime = secs => {
        let hours = Math.floor(secs / (60 * 60));
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);
        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = ("0" + divisor_for_seconds).slice(-2); // to display as 00 instead of 0
        return {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
    };

    updateConversationsIfNecessary = (state, props) => {
        const updatedConversationList = props.conversationList;
        const currentConversationList = state.conversationList;

        const updateConversation = !equals(currentConversationList, updatedConversationList);

        if (updateConversation) {
            return {
                conversationList: updatedConversationList
            }
        } else {
            return null;
        }
    };

    mapSessionTimeRemaining = (state, props) => {
        if (props.sessionTime) {
            return {
                seconds: props.sessionTime
            }
        }
    };

    render() {
        const { conversationHash } = this.props.match.params;
        const { error, loadingState, switchConversation } = this.props;
        const sessionHasTimedOut = this.state.time && this.state.time.m === 0 && this.state.time.s === '00';
        return (
            sessionHasTimedOut ?
                <Redirect to={`/reverify/${conversationHash}`}/> :
                <Menu
                    error={error}
                    loadingState={loadingState}
                    conversationList={this.state.conversationList}
                    sessionTime={this.state.time}
                    switchConversation={switchConversation}
                />
        );
    }
}

const mapStateToProps = state => ({
    loadingState: state.loadingState,
    error: state.menu.error,
    sessionTime: state.session.time,
    conversationList: state.menu.conversationList,
});

const mapDispatchToProps = dispatch => ({
    getAllConversations: () => dispatch(getAllConversations()),
    getSessionTime: () => dispatch(getSessionTime()),
    switchConversation: conversationHash => dispatch(switchConversation(conversationHash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withChatContext(MenuContainer));